// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__editingContainer--w31iI {\n  width: 100%;\n}\n.s-module__reviewContainer--fHriw {\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/PPAOnboardingReviewPage/components/ConsentForms/s.module.less"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;AAEA;EACI,WAAA;AAAJ","sourcesContent":[".editingContainer {\n    width: 100%;\n}\n\n.reviewContainer {\n    width: 100%;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editingContainer": "s-module__editingContainer--w31iI",
	"reviewContainer": "s-module__reviewContainer--fHriw"
};
export default ___CSS_LOADER_EXPORT___;
